export default "__VITE_ASSET__53a6ba8a__"